export default function Django_Elastic_Beanstalk() {
  return <div>Django_Elastic_Beanstalk Component</div>;
}
